import React from 'react';

export default function ANP({item,handleANPOtherDetailsChange,handleANPTotalCostChange,handleANPTotalValueChange,isExtended}) {
  return (
      <>
      <div className="promotion_main_page">
                        <div className="control_panel_upper">
                          <div className="panel_first">
                            <label>Project Code </label>
                            <label> {item.ProjectCode} </label>
                            <div className="cp_inner_second">
                              <label>Total Volume <span className='mandatory_fields' >*</span></label>
                              <label className="long_input">
                                <input
                                  type="number"
                                  name="TotalVolume"
                                  value={item.TotalVolume}
                                  onChange={(e) => {isExtended === true?void 0 : handleANPTotalValueChange(e)}}
                                  disabled={isExtended === true?true:false}
                                  style={isExtended === true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}
                                />{" "}
                              </label>
                            </div>
        
                          </div>
                          <div className="panel_first">
                            <label>Detail of Offer </label>
                            <label> {!item.DetailOfOffer ? "-" : item.DetailOfOffer} </label>
                         
                            <div className="cp_inner_second">
                              <label>Total Cost <span className='mandatory_fields' >*</span></label>
                              <label className="long_input">
                                <input
                                  type="number"
                                  name="TotalCost"
                                  value={item.TotalCost}
                                  onChange={(e) => {isExtended === true?void 0 : handleANPTotalCostChange(e)}}
                                  disabled={isExtended === true?true:false}
                                  style={isExtended === true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}
                                />{" "}
                              </label>
                            </div>
                          </div>
                          <div className="panel_first" style={{ position: 'relative', top: '12.1vh' }} >

                            <div
                              className="cp_inner_second"
                              style={{ marginTop: "0px" }}
                            >
                              <label>Other Details <span className='mandatory_fields' >*</span> </label>
                              <label style={{ paddingBottom: "1.1vw" }}>
                                {" "}
                                <input
                                  type="text"
                                  className="other_detail_input"
                                  onChange={(e) => {isExtended === true?void 0 : handleANPOtherDetailsChange(e)}} 
                                  name="otherDetails"
                                  value={item.OtherDetails}
                                  disabled={isExtended === true?true:false}
                                  style={isExtended === true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}
                                />{" "}
                              </label>
                             
                            </div>
                          </div>
                        </div>
                      </div>
                  
      </>
  );
}
